module.exports = __webpack_public_path__ + "img/citi.33fb2bee.svg";